import React, { useEffect, useState } from "react"
import Dropdown from "../atoms/Dropdown.atom"
import { useSession } from "../../hooks/auth/useSession.hook"
import { getTeamMembersVacationReport } from "../../services/vacation.service"
import DropdownCustomFilterSearch from "./DropdownCustomFilterSearch.molecule"
import useMount from "../../hooks/useMount"
import { useIsAdmin } from "../../hooks/auth/useIsAdmin.hook"


const VacationsReportTeamMemberDropdown = ({
  selectedTeamMember,
  setSelectedTeamMember,
  initiallySelected,
  placeholder = "Selecciona un miembro",
  optionLabel = "userName",
  scrollHeight,
  id = `team-member-dropdown-${new Date().getTime()}`,
  ...props
}) => {
  const [options, setOptions] = useState([])
  const auth = useSession()
  const isAdmin = useIsAdmin();

  async function fetchTeamMembers() {
    const response = await getTeamMembersVacationReport()
    if (response.success) {
      
      setOptions(response.result)
      if (!isAdmin) {
        const teamMemberData = response.result.find(
          (member) => member.id === auth.user.id
        )
        setSelectedTeamMember(teamMemberData)
      }
    }
  }

  useMount(fetchTeamMembers)

  const itemTemplate = (item) => (
    <div className="overflow-hidden white-space-nowrap w-full text-overflow-ellipsis">
      <i className="pi pi-user mr-2"></i>
      <span>{item?.teamMemberNameTag} - </span>
      <span>
        {item?.userName}
      </span>
    </div>
  )

  useEffect(() => {
    if (!selectedTeamMember && initiallySelected) {
      setSelectedTeamMember(initiallySelected(options))
    }
  }, [selectedTeamMember, initiallySelected, options])

  return (
    <Dropdown
      inputId={id}
      options={options}
      optionValue={props.optionValue}
      value={selectedTeamMember?.[props.optionValue] ?? null}
      onChange={(e) => {
        if (props.optionValue) {
          setSelectedTeamMember(
            options.find((option) => option[props.optionValue] === e.value)
          )
        } else {
          setSelectedTeamMember(e.value)
        }
      }}
      resetFilterOnHide
      panelClassName="team-member-dropdown-panel max-w-23rem"
      scrollHeight={scrollHeight || "417px"}
      optionLabel={optionLabel}
      placeholder={placeholder}
      itemTemplate={itemTemplate}
      valueTemplate={(item) => {
        if (!item) return placeholder
        return itemTemplate(item)
      }}
      filter
      filterBy="teamMemberNameTag,userName"
      filterTemplate={(props) => <DropdownCustomFilterSearch props={props} />}
      emptyFilterMessage="Sin resultados ¿Seguro que trabaja aquí?"
      disabled={options.length === 0}
      {...props}
    />
  )
}

export default VacationsReportTeamMemberDropdown
